import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
const MountAnimation = (props) => {
    const [isMounted, setIsMounted] = useState(props.isVisible);
    useEffect(() => setIsMounted(props.isVisible), [props.isVisible]);
    return (React.createElement(CSSTransition, { in: isMounted, timeout: props.timeout, classNames: props.classNames, unmountExit: props.unmountExit }, props.children));
};
export { MountAnimation };
